// Primary content categories used for pre-paid sponsor targeting.
// Saved to talent_profiles.targeting_category as the human-readable label.
// Keep this list in sync with the ShoutOut repo copy.
export const TARGETING_CATEGORIES = [
  'Business & Finance',
  'Health & Fitness',
  'Politics & Commentary',
  'Comedy & Humor',
  'Education & Motivation',
  'Technology & AI',
  'Entertainment & Pop Culture',
  'Fashion, Beauty & Style',
  'Food & Cooking',
  'Travel & Culture',
  'Sports',
  'Gaming & Esports',
  'Outdoors & Adventure',
  'Faith, Family & Parenting',
  'Relationships & Dating',
  'Home & Living',
  'News & Current Events',
  'Arts & Creativity',
  'Nonprofit & Community',
  'Automotive',
  'Pets & Animals',
  'Real Estate',
] as const;

export type TargetingCategory = (typeof TARGETING_CATEGORIES)[number];
